import { render, staticRenderFns } from "./SettingsFourDirectionBase.vue?vue&type=template&id=f4851250&"
import script from "./SettingsFourDirectionBase.vue?vue&type=script&lang=js&"
export * from "./SettingsFourDirectionBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports